/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import RoutablePage from '@modules/routing/RoutablePage'
import { connectClusterWizardURL, connectedClustersURL } from '@modules/ccm-user-lib/urls'
import ClusterListPage from '@modules/ccm-components/ClusterListPage'

import CCMFeatureSelectorScreen from '../ccm-components/EmptyConnectedClusterPage'

import { isCCMFeatureActivated } from './feature'

import type { RouteObject } from 'react-router-dom'

export default function getCCMServiceSelectionRoutes(): RouteObject[] {
  if (!isCCMFeatureActivated()) {
    return []
  }

  return [
    {
      path: connectClusterWizardURL(),
      children: [
        {
          index: true,
          element: (
            <RoutablePage title='Services'>
              <CCMFeatureSelectorScreen />
            </RoutablePage>
          ),
        },
      ],
    },
    {
      path: connectedClustersURL(),
      children: [
        {
          index: true,
          element: (
            <RoutablePage title='Connected Clusters'>
              <ClusterListPage />
            </RoutablePage>
          ),
        },
      ],
    },
  ]
}
